export default "__VITE_ASSET__BKB7Ipj3__"